import { render } from "./DFormCheck.vue?vue&type=template&id=f438ea74"
import script from "./DFormCheck.vue?vue&type=script&lang=js"
export * from "./DFormCheck.vue?vue&type=script&lang=js"

import "./DFormCheck.vue?vue&type=style&index=0&id=f438ea74&lang=scss"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__